import { BehaviorSubject } from 'rxjs';
import { Layer } from './layer.model';
import { ILayerGroup } from './layer-group.type';

export class LayerGroup implements ILayerGroup {
  private readonly isVisibleBS = new BehaviorSubject(false);
  public readonly isVisible$ = this.isVisibleBS.asObservable();
  public readonly layers: Layer[] = [];
  public readonly name: string;

  constructor(name: string, isVisible: boolean) {
    this.isVisibleBS.next(isVisible);
    this.name = name;
  }

  public setVisibility(visible: boolean) {
    console.log('set visibility: ', visible);
    this.isVisibleBS.next(visible);
    if (visible) {
      this.layers.forEach(layer => layer.getIsSelected() ? layer.setVisibility(true) : layer.setVisibility(false));
    } else {
      this.layers.forEach(layer => layer.setVisibility(false));
    }
  }

  public addLayer(layer: Layer) {
    this.layers.push(layer);
  }

  public getIsVisible() {
    return this.isVisibleBS.getValue();
  }

}
